import { useState } from 'react'
import Header from './joyride/header'

import { useTranslation } from 'react-i18next'
import Joyride from 'react-joyride'
import { colors } from '../constants/colors'
import trackEvents from '../constants/track-events'
import { useUserContext } from '../context/user-context'
import { mutation } from '../graphql'
import { trackEvent } from '../helpers/analytics'
import { useMount } from '../hooks/use-mount'
import Paragraph from './joyride/paragraph'

const HelpSupportHint = () => {
  const { t } = useTranslation()
  const { activeSpace } = useUserContext()

  const [showHint, setShowHint] = useState(false)

  useMount(() => {
    const opens_app = localStorage.getItem('opens_app')

    if (parseInt(opens_app) === 10 && !activeSpace.hasSeenHelpSupportHint) {
      setShowHint(true)
      trackEvent(trackEvents.SHOW_HELP_SUPPORT_HINT)

      mutation({
        mutation: 'updateSpace',
        input: {
          id: activeSpace.id,
          customer_dashboard_meta: JSON.stringify([
            ...activeSpace.customer_dashboard_meta,
            { event: 'SHOW_HELP_SUPPORT_HINT', status: 'SEEN' }
          ])
        }
      })
    }
  })

  if (showHint === false) return null

  return (
    <Joyride
      hideCloseButton
      locale={{ close: t('help_support_hint.got_it_action') }}
      run
      styles={{
        buttonNext: {
          fontSize: 14,
          backgroundColor: colors.primaryBlue,
          borderRadius: 32,
          padding: '12px 24px',
          fontFamily: 'Fira Sans',
          fontWeight: 600
        }
      }}
      steps={[
        {
          target: '#nav_support_hub',
          disableBeacon: true,
          content: (
            <>
              <Header>{'help_support_hint.title'}</Header>
              <div className='h-4'></div>
              <Paragraph className='mt-2'>
                {'help_support_hint.description'}
              </Paragraph>
            </>
          )
        }
      ]}
    />
  )
}

export default HelpSupportHint
